<div class="artist-card" tabindex="0">
  <div class="artist-card__image" [ngStyle]="{ 'background-image': 'url(' + image?.file + ')' }">
    <img *ngIf="card?.imageUrl" [src]="card.imageUrl" alt="Image of the artist" />
  </div>
  <div class="artist-card__body">
    <p class="artist-card__body--name">{{ card?.name }}</p>
    <ten-follow-button [followButtonData]="card.followButton" class="artist-card__body--button"></ten-follow-button>
  </div>
</div>
